// extracted by mini-css-extract-plugin
export default {"navbar":"Navbar_navbar__n7ygh","navLinks":"Navbar_navLinks__UMGgk"};